import {
  GraphQLEnv,
  getConfigValue,
  graphqlEnv,
  graphqlGatewayEnv,
  isNative,
} from 'utils/environment';

// TODO remove this after we test that using the configured URL works as expected
export const getUrl = (configuredUrl: string, webUrl: string): string => {
  const awsConfig = getConfigValue('aws');

  if (awsConfig.env !== 'prod') {
    // for non-production environments, use the configured URL
    return configuredUrl;
  }

  // test out bk ch first, if it matches, return the configured URL
  if (awsConfig.country === 'ch' && awsConfig.brand === 'bk') {
    return configuredUrl;
  }

  // else, return the webUrl for all other markets
  return webUrl;
};

export const getGraphqlApiUrl = () => {
  const awsConfig = getConfigValue('aws');
  return graphqlEnv() === GraphQLEnv.TEST || graphqlEnv() === GraphQLEnv.LOCAL
    ? 'http://localhost:3001/graphql'
    : isNative
      ? awsConfig.gqlApiUrl
      : getUrl(awsConfig.gqlApiUrl, '/api/whitelabel');
};

export enum QUERY_TYPE {
  LambdaGraphqlQuery,
  SanityGroqQuery,
  SanityGraphqlQuery,
}

export const getGraphqlGatewayApiUrl = () => {
  const awsConfig = getConfigValue('aws');
  switch (graphqlGatewayEnv()) {
    case GraphQLEnv.TEST:
      return 'https://use1-dev-bk-gateway.rbictg.com/graphql';
    case GraphQLEnv.LOCAL:
      return 'http://localhost:3002/graphql';
    default:
      return isNative
        ? awsConfig.gqlGatewayApiUrl
        : getUrl(awsConfig.gqlGatewayApiUrl, '/api/gateway');
  }
};

export enum HttpErrorCodes {
  BadRequest = 400,
  InternalServerError = 500,
  TooManyRequests = 429,
  Unauthorized = 401,
}
